import * as React from "react";
import { SettingPage } from "../components";


const Setting: React.FC = () => {
    return (
        <SettingPage />
    );
};

export default Setting;